module.exports = __webpack_public_path__ + "img/hc-icon08.896c955e.svg";